import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import ProductCenter from '@/components/ProductCenter'
import ProductDetail from '@/components/ProductDetail'
import ProductPC from '@/components/ProductPC'
import ProductDetailPC from '@/components/ProductDetailPC'
import PictureShow from '@/components/PictureShow'
import MoreAD from '@/components/MoreAD'


Vue.use(Router)

export default new Router({
  routes: [
   {
    path: '',
    name: 'Login',
    component: Login
   },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
   {
    path: '/ProductCenter',
    name: 'ProductCenter',
    component: ProductCenter,
   },
   {
    path: '/ProductDetail',
    name: 'ProductDetail',
    component: ProductDetail,

   },
   {
    path: '/PictureShow',
    name: 'PictureShow',
    component: PictureShow,
   },
   {
    path: '/MoreAD',
    name: 'MoreAD',
    component: MoreAD,
   },
   {
    path: '/ProductPC',
    name: 'ProductPC',
    component: ProductPC,
   },
   {
    path: '/ProductDetailPC',
    name: 'ProductDetailPC',
    component: ProductDetailPC,
   },
   {
    path: '/prod',
    beforeEnter () {
     window.location.href='http://www.want-want.com/products/Drink_73466068433108992.aspx'
    }
   },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js